__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@kne-components/ai-evaluation";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@kne/react-fetch", "1.5.5", () => (Promise.all([__webpack_require__.e(115), __webpack_require__.e(201), __webpack_require__.e(884), __webpack_require__.e(969)]).then(() => (() => (__webpack_require__(3201))))));
			register("@kne/remote-loader", "1.2.3", () => (Promise.all([__webpack_require__.e(115), __webpack_require__.e(601), __webpack_require__.e(884), __webpack_require__.e(418)]).then(() => (() => (__webpack_require__(8601))))));
			register("@kne/use-ref-callback", "0.1.2", () => (Promise.all([__webpack_require__.e(884), __webpack_require__.e(400)]).then(() => (() => (__webpack_require__(1400))))));
			register("antd", "5.22.1", () => (Promise.all([__webpack_require__.e(636), __webpack_require__.e(884), __webpack_require__.e(469), __webpack_require__.e(486)]).then(() => (() => (__webpack_require__(1636))))));
			register("axios", "1.7.7", () => (__webpack_require__.e(963).then(() => (() => (__webpack_require__(4344))))));
			register("dayjs", "1.11.13", () => (__webpack_require__.e(446).then(() => (() => (__webpack_require__(446))))));
			register("echarts-for-react", "3.0.2", () => (Promise.all([__webpack_require__.e(343), __webpack_require__.e(884), __webpack_require__.e(467)]).then(() => (() => (__webpack_require__(7343))))));
			register("echarts", "5.5.1", () => (Promise.all([__webpack_require__.e(57), __webpack_require__.e(344)]).then(() => (() => (__webpack_require__(3057))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-router-dom", "6.28.0", () => (Promise.all([__webpack_require__.e(245), __webpack_require__.e(884), __webpack_require__.e(486)]).then(() => (() => (__webpack_require__(3245))))));
			register("react", "18.2.0", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};